<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="客户姓名：">
            <el-input v-model="query.userRealName" placeholder="请输入客户姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="query.userMobile" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="客服信息：">
            <el-select v-model="query.fromUserId" placeholder="请选择" filterable clearable size="small">
              <el-option v-for="(item,index) in serviceOptions" :key="index" :label="item.realName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份：">
            <el-select v-model="query.levelId" placeholder="请选择" filterable clearable size="small">
              <el-option v-for="(item,index) in levelOptions" :key="index" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="标签组" prop="archiveGroupTitle" align="center" width="200" fixed />
        <el-table-column label="会话标签" prop="archiveTagTitle" align="center" />
        <el-table-column label="客户姓名" prop="toUserRealName" align="center" />
        <el-table-column label="身份" prop="toUserLevelName" align="center" />
        <el-table-column label="手机号" prop="toUserMobile" align="center" />
        <el-table-column label="客服信息" prop="fromUserRealName" align="center" />
        <el-table-column label="客服评分" prop="score" align="center" />
        <el-table-column label="会话时间" prop="messageTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">查看会话内容</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <chat-history-vue ref="chatHistoryVue" />
  </div>
</template>

<script>
import imConversationApi from '@/api/customer/imConversation'
import Pagination from '@/components/Pagination'
import custServiceStaffApi from '@/api/customer/custServiceStaff'
import customerLevelApi from '@/api/sys/customerLevel'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
import chatHistoryVue from '../message/other/chatHistory.vue'
export default {
  props: ['rowItem'],
  components: {
    Pagination,
    chatHistoryVue
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      serviceOptions: [],
      levelId: '',
      levelOptions: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getServiceList()
    this.getCustomerLevel()
  },
  methods: {
    getCustomerLevel() {
      customerLevelApi.fetchList().then(({ data }) => {
        let arr = []
        data.forEach(item => {
          arr.push({ value: item.name, key: `_${item.id}`, type: 1 })
        })
        this.levelOptions = this.levelOptions.concat(arr);
        this.getTechnicalServiceLevel()
      })
    },
    getTechnicalServiceLevel() {
      technicalServiceLevelApi.findOptions().then(({ data }) => {
        data.forEach(item => { item.type = 2 })
        this.levelOptions = this.levelOptions.concat(data)
      })
    },
    getServiceList() {
      custServiceStaffApi.fetchForList().then(({ data }) => {
        this.serviceOptions = data
      })
    },
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    calcQuery() {
      // this.query.archiveTagId = this.rowItem.id;
      this.query.customerLevelId = undefined
      this.query.techLevelId = undefined
      if (this.levelId) {
        let find = this.levelOptions.find(item => item.key === this.levelId);
        console.log(find)
        if (find.type === 1) {
          this.query.customerLevelId = find.key.replace('_','')
        } else if (find.type === 2) {
          this.query.techLevelId = find.key
        }
      }
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.calcQuery()
      this.query.status = 30
      this.listLoading = true
      return imConversationApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => imConversationApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择数据')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => imConversationApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      imConversationApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.learnAdd.handleCreate(row)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.learnAdd.handleUpdate(row)
    },
    handleShow(row) {
      this.$refs.chatHistoryVue.handleShow(row)
    }
  }
}
</script>
<style lang="scss" scoped>
.coutomer-time {
  i {
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
    padding-left: 5px;
  }
}
</style>